export default __webpack_public_path__ + "static/media/hodotsAPI.902baf67.md";